// extracted by mini-css-extract-plugin
export default {"articleBox":"index_articleBox_q-mh8","end":"index_end_qb1aX"};